module.exports = __webpack_public_path__ + "img/about6.ccce1785.png";